import { storyblokEditable } from '@storyblok/react/rsc'
import { type FC } from 'react'

import { IconCaretLeft } from '@redteclab/icons'

import { Link } from 'base-ui'

import { getStoryblokHrefLink } from '../../getStoryblokHrefLink'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokCategorySectionType } from '../../model/storyblokTypes.generated'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

export const StoryblokCategorySection: FC<
  StoryblokComponentProps<StoryblokCategorySectionType>
> = ({ blok }) => {
  const previousPageLink = blok.previousPageLink?.[0]

  return (
    <div
      {...storyblokEditable(blok)}
      className="flex w-full flex-col-reverse gap-10 tablet:flex-row"
      id={blok.id}
    >
      <div className="flex-col flex-nowrap text-m tablet:flex tablet:w-[240px]">
        {previousPageLink ? (
          <div className="mt-1.5 hidden border-b border-dark-primary-strong pb-5 font-medium tablet:flex">
            <IconCaretLeft className="size-6" />
            <a href={getStoryblokHrefLink(previousPageLink.link)}>
              {previousPageLink.text}
            </a>
          </div>
        ) : null}
        <span className="hidden py-2 font-medium tablet:block">
          {blok.categoryName}
        </span>
        <div className="flex flex-col gap-4">
          <div className="hidden gap-1 tablet:flex tablet:flex-col">
            {blok.subCategories?.map((subCategory) => {
              const { _uid: key, link, text } = subCategory

              return (
                <Link
                  className="border-b border-dark-primary-min pb-1 pl-2 text-dark-primary-strong no-underline"
                  href={getStoryblokHrefLink(link)}
                  key={key}
                >
                  {text}
                </Link>
              )
            })}
          </div>
          <StoryblokComponentsRenderer bloks={blok.faqContent ?? []} />
        </div>
      </div>
      <div className="flex w-full min-w-0 flex-col gap-8 tablet:gap-12">
        {blok.content ? (
          <StoryblokComponentsRenderer bloks={blok.content} />
        ) : null}
      </div>
    </div>
  )
}
